// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__W7hQu","confirmAlert":"styles_confirmAlert__kMHr1","confirmAlertButtons":"styles_confirmAlertButtons__ZhAF4","buttonNoWrap":"styles_buttonNoWrap__ErKfl"};